import { createNode, InstantDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromInstant } from '../../utils/temporal';

export const InstantNode = createNode({
    id: 'Instant',
    name: 'Instant',
    description: 'Creates an Instant from epoch milliseconds',
    aiDescription:
        'Takes a number on the "Epoch Milliseconds" port and outputs an Instant on the "Instant" port representing that point in time.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        'Epoch Milliseconds': { kind: 'number' },
    },
    outPorts: {
        Instant: InstantDataType,
    },
    execute: function (input) {
        const instant = Temporal.Instant.fromEpochMilliseconds(input.inPorts['Epoch Milliseconds']);
        return { output: { Instant: fromInstant(instant) } };
    },
});
